import {
  Button,
  Header,
  Modal,
  ModalActions,
} from '@lightspeed/design-system-react'
import { reactular } from '@vendhq/reactular'
import React, { FC } from 'react'
import { vn } from 'vend-number'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'

interface Props {
  close: (amount: Promise<number>) => void
  amountTendered: number
  balance: number
  cashDiscountedBalance: number
}

export const CashDiscountingModal: FC<Props> = ({
  close,
  amountTendered,
  balance,
  cashDiscountedBalance,
}) => {
  const vdCurrencyFilter = useVdCurrencyFilter()

  const tenderedAmountMatchesBalance = vn(amountTendered).eq(balance)

  const payCashDiscountedAmount = () => {
    close(Promise.resolve(cashDiscountedBalance))
  }

  const payTenderedAmount = () => {
    close(Promise.resolve(amountTendered))
  }

  const closeModal = () => {
    close(Promise.reject(new Error('Rejected pay with cash discounting')))
  }

  return (
    <Modal onClose={closeModal} size="small">
      <div className="vd-dialog-header">
        <div className="vd-header vd-header--dialog vd-align-center">
          <Header level="1" type="hero">
            Collect {vdCurrencyFilter(cashDiscountedBalance)}
          </Header>
          <div className="vd-text--intro vd-text--secondary">
            Quick cash payment
          </div>
        </div>
      </div>

      <ModalActions className="vd-align-center">
        <div className="vd-btn-group">
          {tenderedAmountMatchesBalance && (
            <Button variant="go" onClick={payCashDiscountedAmount}>
              {vdCurrencyFilter(cashDiscountedBalance)}
            </Button>
          )}
          <Button
            variant={tenderedAmountMatchesBalance ? 'supplementary' : 'go'}
            onClick={payTenderedAmount}
          >
            {vdCurrencyFilter(amountTendered)}
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}

export const CashDiscountModalComponent = reactular(
  CashDiscountingModal,
  ['close', 'amountTendered', 'balance', 'cashDiscountedBalance'],
  'reactWrapper'
)
